// @flow

import * as React from 'react';
import {useContext, useReducer} from 'react';
import {contextStubFunction} from 'docs/util';
import type {FileContent} from 'docs/data/integration-builder';
import {FileDownloadReducer} from './FileDownloadReducer';
import type {FileDownloadReducerState} from './FileDownloadReducer';
import {downloadFiles} from './actions/downloadFiles';

export type FileDownloadActions = {|
  downloadFiles: (files: FileContent) => Promise<void>,
|};

export type FileDownloadContextType = {
  ...FileDownloadReducerState,
  ...FileDownloadActions,
};

export const FileDownloadContext = React.createContext<FileDownloadContextType>(
  {
    isDownloading: false,
    error: '',
    success: false,
    downloadFiles: contextStubFunction('FileDownload'),
  },
);

type FileDownloadProviderProps = {|
  children: React.Node,
|};

export const FileDownloadProvider = (props: FileDownloadProviderProps) => {
  const [state, dispatch] = useReducer(FileDownloadReducer, {
    isDownloading: false,
    error: '',
    success: false,
  });

  const context = {
    ...state,
    downloadFiles: downloadFiles(dispatch),
  };

  return (
    <FileDownloadContext.Provider value={context}>
      {props.children}
    </FileDownloadContext.Provider>
  );
};

export const useFileDownload = () => {
  return useContext(FileDownloadContext);
};
